import Vue from 'vue';
import axios from 'axios';
import VueAxios from 'vue-axios';
import params from '@/config/params';
import store from '@/store/store';
import { ERROR_CODES, HTTP_STATUSES, REQUEST_HEADERS } from '@/helpers/constants';

let orderUpdateTime = null;

if (!sessionStorage.getItem('tabId')) {
    sessionStorage.setItem('tabId', Date.now());
}

axios.defaults.baseURL = params.apiDomain;
axios.defaults.headers.common[REQUEST_HEADERS.xBrowserTabId] = sessionStorage.getItem('tabId');

axios.interceptors.request.use(config => {
    const locale = localStorage.getItem('locale');
    config.headers[REQUEST_HEADERS.xOrderUpdateTime] = orderUpdateTime;
    config.headers['X-Language'] = locale;
    return config;
});

axios.interceptors.response.use(
    response => {
        if (response.headers[REQUEST_HEADERS.xOrderUpdateTime]) {
            orderUpdateTime = response.headers[REQUEST_HEADERS.xOrderUpdateTime];
        }

        store.commit('SetIsAnyRequestLoading', false);
        return response;
    },
    (err) => {
        if (
            err.response?.status === HTTP_STATUSES.badRequest &&
            err.response?.data?.code === ERROR_CODES.accessDenied
        ) {
            store.commit('setPageAccess', false);
        }

        if (err.response?.data?.code === ERROR_CODES.notActualOrderVersion) {
            sessionStorage.setItem('isVisibleModalReload', true);
            window.location.reload();
        }

        store.commit('SetIsAnyRequestLoading', false);
        return Promise.reject(err);
    },
);

Vue.use(VueAxios, axios);